import React, { Component } from "react";
import "./administrador.css";
import { Container, Row, InputGroupText, Button, InputGroup, Input, Modal } from 'reactstrap';
import Utils from "../../Utils";
import { Cargando } from "../estados/Cargando";
import { AdminTermsCondiciones } from './AdminTermsCondiciones';
import { DetalleProveedor } from './DetalleProveedor';
import { Semaforos } from './Semaforos';
import { Beneficios } from "./Beneficios";
import { Niveles } from "./Niveles";

export class Administrador extends Component {
    constructor(props) {
        super(props);

        this.state = {
            profiledata: [],
            proveedores: [],
            nuevosProveedores: [],
            proveedor: {},
            estado: 0,
            modalSem: false,
            proveedoresItems: [],
            userInfo: { roles: "P" }
        };
        this.proveedores = {};
        this.inputRef = React.createRef();
    }

    componentDidMount() {
        this.getUserInfo();
    }

    abrirModalSem = () => {
        this.setState({ modalSem: true });
    }
    abrirModalBen = () => {
        this.setState({ modalBen: true });
    }
    abrirModalNiv = () => {
        this.setState({ modalNiv: true });
    }

    cerrarModal = () => {
        this.setState({ modalSem: false, modalBen: false, modalNiv: false });
    }

    async getProveedor(cuit) {
        if (this.state.proveedor.Id === undefined || (this.state.proveedor.Id !== undefined && Number(this.state.proveedor.Id) !== cuit)) {
            this.setState({ estado: 1 })
            await Utils.getProveedorInfo(cuit)
                .then(data => {
                    if (data !== undefined)
                        this.setState({ proveedor: data, estado: 2 })
                });
        }
    }

    async getUserInfo() {
        await Utils.getUserInfo()
            .then(data => {
                let d = data.status;
                if (d === 200) {
                    this.setState({ userInfo: data.data });
                    if (data.data.roles === "A" || data.data.roles === "V")
                        this.getListaProveedores();
                }
            });
    }

    async getListaProveedores() {
        await Utils.getProveedores()
            .then(data => {
                if (data !== undefined) {
                    this.setState({ proveedores: data });
                }
            });
    }

    async filtrarTabla (columna) {
        const tabla = document.getElementById("tablaProveedores");
        const input = tabla.getElementsByTagName("input")[columna];
        const filtro = input.value.toUpperCase();
        const filas = tabla.getElementsByTagName("tbody")[0].getElementsByTagName("tr");

        for (let i = 0; i < filas.length; i++) {
            const celdas = filas[i].getElementsByTagName("td");
            if (celdas[columna]) {
                const texto = celdas[columna].textContent || celdas[columna].innerText;
                filas[i].style.display = texto.toUpperCase().indexOf(filtro) > -1 ? "" : "none";
            }
        }
    }

    cambioHandler(id, nuevoValor) {
        const nuevosInputs = this.state.proveedores.map((input) =>
            input.cuit === id ? ({ ...input, motivo: nuevoValor }) : input
        );

        const nuevosProveedores = nuevosInputs.map((input, index) =>
            input.cuit === id || this.state.nuevosProveedores[index] != null ? input : null
        );

        if (this.state.userInfo.roles === "A") {
            this.setState({ proveedores: nuevosInputs });
            this.setState({ nuevosProveedores: nuevosProveedores});
        }
    }

    checkHandler(id, nuevoValor) {
        const nuevosInputs = this.state.proveedores.map((input) =>
            input.cuit === id ? { ...input, habilitado: nuevoValor.checked } : input
        );

        const nuevosProveedores = nuevosInputs.map((input, index) =>
            input.cuit === id || this.state.nuevosProveedores[index] != null ? input : null
        );

        if (this.state.userInfo.roles === "A") {
            this.setState({ proveedores: nuevosInputs });
            this.setState({ nuevosProveedores: nuevosProveedores });
        }
    }

    fechaFormato(fechaInput, version) {

        if (fechaInput != null) {
            const fecha = new Date(fechaInput);

            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const dia = String(fecha.getDate()).padStart(2, '0');
            const anio = String(fecha.getFullYear()).slice(-2);

            return `${version} - ${dia}/${mes}/${anio}`;
        }
        else return "";
    }

    async setLista(table) {
        table.disabled = true
        table.textContent = "Guardando"
        let json = "[";
        /*for (let i = 2; i < table.form.elements.length - 1; i++) {
    let add = "";
    add += "{\"cuit\":" + table.form.elements[i++].value + ",";
    add += "\"habilitado\":" + table.form.elements[i++].checked + ",";
    add += "\"motivo\":\"" + table.form.elements[i].value + "\"},";
    if (!table.form.elements[i - 1].checked) json += add;
}*/
        this.state.nuevosProveedores.forEach(function (prov) {
            if (prov != null) {
                json += `{"cuit":"${prov.cuit}",`;
                json += `"habilitado":${prov.habilitado}`;
                json += prov.motivo && prov.motivo.trim() ? `,"motivo":"${prov.motivo}"},` : `},`;
            }
        });

        json = json.slice(0, -1) + "]"; // elimina la �ltima coma y cierra el array

        console.log(json);
        await Utils.setProveedorInfo(json)
            .then(data => {
                if (data !== undefined) {
                    table.disabled = false
                    table.textContent = "Guardar"
                }
            })
    }

    render() {
        let contenido;
        switch (this.state.estado) {
            case 0:
                contenido = <div><br/>Seleccione proveedor</div>
                break;
            case 1:
                contenido = <Cargando></Cargando>;
                break;
            case 2:
                contenido = <DetalleProveedor proveedor={this.state.proveedor}></DetalleProveedor>
                break;
            default:
                contenido = <div><br />Seleccione proveedor</div>;
        }

        return (
            <>
                {(this.state.userInfo.roles === "A" || this.state.userInfo.roles === "V") ?
                    <>
                        <AdminTermsCondiciones rol={this.state.userInfo.roles} />
                        <Container>
                            <Row>
                                <div className="col-3">
                                    <Button outline onClick={() => this.abrirModalSem()}>
                                        <img src="/r.png" alt="Semaforos" width="19px" />
                                    </Button>
                                    {/*&nbsp;&nbsp;*/}
                                    {/*<Button outline onClick={() => this.abrirModalBen()}>*/}
                                    {/*    <img src="/b.png" alt="Beneficios" width="19px" />*/}
                                    {/*</Button>*/}
                                    &nbsp;&nbsp;
                                    <Button outline onClick={() => this.abrirModalNiv()}>
                                        <img src="/n.png" alt="Niveles" width="19px" />
                                    </Button>
                                </div>
                            </Row>
                            <Row>
                                <div className="col-5">
                                    {contenido}  
                                </div>
                                <div className="col-7">
                                <form id="listaForm">
                                    <table className="lista" id="tablaProveedores">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Razon Social<br/>
                                                    <input type="search" onChange={() => this.filtrarTabla(0)} placeholder="Buscar..." style={{ width: "279px" }}/>
                                                </th>
                                                <th>
                                                    Cuit<br/>
                                                        <input type="search" onChange={() => this.filtrarTabla(1)} placeholder="Buscar..." style={{ width: "130px" }}/>
                                                </th>
                                                <th style={{ width: "160px" }}>
                                                    Habilitado<br/>
                                                </th>
                                                <th style={{ width: "150px" }}>
                                                    Terminos y <br/> condiciones
                                                </th>
                                            </tr>
                                            </thead>
                                            { this.state.proveedores.length>0 ?
                                                <tbody id="listaProv" ref={this.inputRef}>
                                                    { this.state.proveedores.map((prov) => (
                                                        <tr onClick={() => this.getProveedor(prov.cuit)}>
                                                            <td style={{ width: "279px" }}>
                                                                <input type="hidden" name="cuit" value={prov.cuit}/>
                                                                &nbsp;{prov.razonSolcial}
                                                            </td>
                                                            <td style={{ width: "130px" }}>
                                                                &nbsp;{prov.cuit}
                                                            </td>
                                                            <td style={{ width: "160px" }}>
                                                                <InputGroup size="sm"> {
                                                                    this.state.userInfo.roles === "A" ?
                                                                    <>
                                                                        <InputGroupText >
                                                                            <Input addon aria-label="Check para habilitar" type="checkbox" name="habilitado" checked={prov.habilitado} onClick={(e) => this.checkHandler(prov.cuit, e.target)} />
                                                                        </InputGroupText>
                                                                        <Input onChange={(e) => this.cambioHandler(prov.cuit, e.target.value)} name="motivo"  value={prov.motivo} />
                                                                    </> 
                                                                    :
                                                                    <>
                                                                        <InputGroupText >
                                                                            <Input addon aria-label="Check para habilitar" type="checkbox" name="habilitado" checked={prov.habilitado} />
                                                                        </InputGroupText>
                                                                        <Input name="motivo" value={"prueba"} disabled/>
                                                                    </>
                                                                }
                                                                </InputGroup>
                                                            </td>
                                                            <td style={{ width: "150px" }}>
                                                                &nbsp; {this.fechaFormato(prov.fecha, prov.ultimaVersion)} &nbsp;
                                                            </td>
                                                        </tr>
                                                    ))}

                                                </tbody>
                                                :
                                                <tbody><Cargando></Cargando></tbody>
                                                }
                                        </table>
                                        {this.state.userInfo.roles === "A" ?
                                            <Button color="primary" onClick={(e) => this.setLista(e.target)}>
                                                Guardar
                                            </Button> : null
                                        }
                                    </form>
                                    <br/>
                            
                                </div>
                            </Row>
                        </Container>
                        <Modal isOpen={this.state.modalSem} toggle={() => this.cerrarModal()} size="lg" scrollable={true}>
                            <Semaforos modalSem={() => this.cerrarModal()} rol={this.state.userInfo.roles}></Semaforos>
                        </Modal>
                        <Modal isOpen={this.state.modalBen} toggle={() => this.cerrarModal()} size="xl" scrollable={true}>
                            <Beneficios modalBen={() => this.cerrarModal()} rol={this.state.userInfo.roles}></Beneficios>
                        </Modal>
                        <Modal isOpen={this.state.modalNiv} toggle={() => this.cerrarModal()} size="lg" scrollable={true}>
                            <Niveles modalNiv={() => this.cerrarModal()} rol={this.state.userInfo.roles}></Niveles>
                        </Modal>
                    </> : null
                    }
            </>
        );
    }
}